module.exports = __webpack_public_path__ + "img/solomon_kindley.aae519a0.png";